import { BaseModel } from "../classes/base-model";

export class Installments extends BaseModel {

    BankBkmCode:number;
    BankName:string;
    Installments:any[];
}



// WEBPACK FOOTER //
// ./src/app/models/installments.ts